import React from 'react';
import { NavigationDots, SocialMedia } from '../components';

const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`flex flex-row min-h-screen w-full ${classNames}`}>
      <SocialMedia />
      <div className="flex-col flex-grow px-8 py-16 w-full flex items-center justify-center sm:px-4 sm:pb-8 sm:pt-16">
        <Component />

        
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;